// extracted by mini-css-extract-plugin
module.exports = {"cancel_btn":"ItemWrapper_cancel_btn__sanSs","submit_btn":"ItemWrapper_submit_btn__7Mq2j"};